import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormServiceService } from 'src/app/shared/services/dynamic-form-service.service';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';
import { Constants } from '../../constants';
import { MatAutocompleteTrigger} from '@angular/material/autocomplete';

@Component({
    selector: 'app-select-form',
    templateUrl: './select-form.component.html',
    standalone: false
})
export class OrderSelectFormComponent implements OnInit, OnDestroy {

  constructor(private readonly dynamicService: DynamicFormServiceService, private readonly broadCastService: BroadcastService) { }
  field: OrderFieldConfig;
  group: UntypedFormGroup;
  sortedOptions: any;
  isRequired: boolean;
  required = Constants.IS_REQUIRED;
  specimenAddRemoveEvent: object;
  disableEnableAddButtonEvent: object;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  ngOnInit() {
    this.sortedOptions = this.field.options;
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    this.specimenAddRemoveEvent = this.broadCastService.subscribe().subscribe(message => {
      if (message.type === Constants.IsSpecimenAdded) {
        const res = message.payload;
        if (res.event) {
          const exists = res.param;
          const index = this.sortedOptions.findIndex(x => x.code === exists);
          if (index > -1) {
            this.sortedOptions.splice(index, 1);
            this.group.reset();
          }
        } else if (!res.event) {
          const exists = res.param.SpecimenId;
          if (exists) {
            if (this.sortedOptions.findIndex(x => x.code === exists) < 0) {
              this.sortedOptions.push({ code: exists, value: exists, extras: null, uniqueId: null, timeZoneOffset: 0 });
              this.sortedOptions.sort((a, b) => a.code.localeCompare(b.code));
            }
          }
        }
      } else if (message.type === Constants.CLOSE_MAT_AUTOCOMPLETE) {
        this.closeMatAutocomplete();
      }
    });
  }

  ngOnDestroy(): void {
    this.specimenAddRemoveEvent = null;
  }

  closeMatAutocomplete() {
    this.autocomplete.closePanel();
  }
}
